import { render, staticRenderFns } from "./HeaderLink.vue?vue&type=template&id=f8df48ee&scoped=true&"
import script from "./HeaderLink.vue?vue&type=script&lang=ts&"
export * from "./HeaderLink.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderLink.vue?vue&type=style&index=0&id=f8df48ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8df48ee",
  null
  
)

export default component.exports